<template>
    <el-dialog  title="编辑问题" :visible.sync="showBlock" :destroy-on-close="true" width="500px" :before-close="handleClose">
        <div class="warp-form">
            <el-form :model="formDate" ref="formDate" label-width="80px" class="demo-ruleForm">
                <el-form-item  label="标题内容" prop="problem"   :rules="[{required:true,message:'标题内容不能为空'}]">
                    <el-input v-model="formDate.problem" maxlength="40" placeholder="请输入问题" autocomplete="off"></el-input>
                </el-form-item>
                
                <el-form-item  label="内容描述" prop="answer" :rules="[{required:true,message:'内容描述不能为空'}]">
                    <el-input v-model="formDate.answer" type="textarea" maxlength="500" placeholder="请输入内容" show-word-limit :autosize="{minRows:3}"  autocomplete="off"></el-input>
                </el-form-item>
                <div class="warp-btn">
                    <el-form-item>
                        <div  class="dialog-footer">
                            <el-button @click="handleClose">取消</el-button>
                            <el-button type="primary" @click="submitForm('formDate')">提交</el-button>
                        </div>
                    </el-form-item>
                </div>
            </el-form>
        </div>
    </el-dialog>
</template>
<script>
  import {url,operate} from '@/utils/config'
  import {postFun,putFun} from '@/utils/httpFun'
  export default{

     data(){
       return{
            maks:'add',
            formDate: {
				problem: "",
                answer: "",
                id:"",
				publishPlatform:"",
				operator:""
            },
            showBlock: false,
       }
     }, 
     created(){
       
     },
     methods:{

        //重置输入框信息
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        //提交
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.addMess()
                } else {
                  console.log('error submit!!');
                  return false;
                }
            });
        },

        //新增BTn
        async addMess(){
            let parms = {
                problem:this.formDate.problem, 
                answer:this.formDate.answer,
                
            }
            parms.operator = this.$store.state.operator
			parms.publishPlatform =1//	发布平台1：运营 2：工厂 3：代理商 4：工程商
            let urlHttp = operate.INSERTPROBLEM 
            if(this.maks=="eidt"){
				//编辑
                urlHttp = operate.UPDATEPROBLE 
                parms.id = this.idDS
                await postFun(urlHttp,parms,res=>{
                  if(res.code==1){
                     this.$parent.resetBtn()
                     this.showBlock = false
                     this.handleClose()
                  }
                })
            }else if(this.maks=="add"){
				//新增
				console.log(parms)
				console.log(urlHttp)
                await postFun(urlHttp,parms,res=>{
                  if(res.code==1){
                     this.$parent.resetBtn()
                     this.showBlock = false
                     this.handleClose()
                  }else{
					  console.log(res)
				  }
                })
            }else{
				//查看
			}
            
        },

        //开启弹窗
        showMessage(ev,val){
			console.log("11",val.id)
           this.showBlock = true
           if(ev=="eidt"){
              this.maks = "eidt"
              this.idDS = val.id
              this.formDate={
                    answer:val.answer,
                    problem:val.problem,
                    id:val.id,
               }
           }else if(ev=="add"){
              this.maks = "add" 
           }
		   else if(ev=="look"){
			   this.maks="look"
			   this.formDate={
			         answer:val.answer,
			         problem:val.problem,
			         id:val.id,
			    }
		   }
        },
       
        //关闭弹窗
        handleClose() {
            this.showBlock = false
            this.formDate={
                Name:"",
                Value:"",
                remarks:"",
            }
           
        }
     }
  }
</script>
<style scoped lang="scss">
   .dialog-footer{
       display: flex;
       justify-content: flex-end;
   }
   .warp-btn{
    .el-form-item {
        margin-bottom:0px!important;
     }
   }
   .warp-form{
      ::v-deep .el-input__count{
         background-color: rgba(0, 0, 0, 0);
      }
   }
   
</style>